import React, { useEffect, useState } from "react";
import Highlighter from "react-highlight-words";
import { CiEdit } from "react-icons/ci";
import { deleteGroupDelete, deleteRowDelete, updateDefaultFieldsArray } from "../../candidateListFunctions";
import { IoSettingsOutline } from "react-icons/io5";
import { useDispatch } from "react-redux";
import CandidateFilterPopup from "../../CandidateFilterPopup";
import { AiOutlineCloudUpload, AiOutlineFilter } from "react-icons/ai";
import SettingsPopup from "../../../../../../../../ReusableComponents/SettingsPopup/SettingsPopup";
import PromptElement from "../../../../../../PromptElement";
import TableAllocatedVisaDetails from "./TableAllocatedVisaDetails";
import { RiFileExcel2Line } from "react-icons/ri";
import { HiOutlineSquaresPlus } from "react-icons/hi2";
import { FaUserEdit } from "react-icons/fa";
import selectionList from "../../excel/SelectionList";
import FileUploadPopup from "./FileUploadPopup";
import CandidateErrorPopUp from "../../CandidateErrorPopUp";
import DownloadPDFPopup from "./DownloadPDFPopup";
import visaDetailsTemplate from "../../excel/VisaDetailsTemplate";
import { Tooltip } from "react-tooltip";
import EditUpdatedVisaCandidate from "./EditUpdatedVisaCandidate";
import GroupEditPopupVisaDetails from "./GroupEditPopupVisaDetails";
import FileUploadPopup_VISA from "./FileUploadVisaStamp";
import SearchFilter from "../../../../../../../../components/SmartDataTable/SearchFilter";
import PaginationControls from "../../../../../../../../components/SmartDataTable/PaginationControls";

const PAGE_SIZE_OPTIONS = [10, 25, 50, 100];

export default function ListDataUpdateVisaDetails({
  candidateData = [],
  setCandidateListData,
  projectId,
  setOpenCandidateUpload,
}) {
  const dispatch = useDispatch();

  const [searchTerm, setSearchTerm] = useState("");
  const [searchWords, setSearchWords] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(50);

  const [filterView, setFilterView] = useState(false);
  const [filteringKeys, setFilteringKeys] = useState({});
  const [showSettings, setShowSettings] = useState(false);
  const [openDeletePopup, setOPenDeletePopup] = useState({ open: false, id: "" });
  const [groupEditPopupState, setGroupEditPopupState] = useState({ open: false });
  const [groupDeletePopupState, setGroupDeletePopupState] = useState({ open: false });
  const [editCandidatePopup, setEditCandidatePopup] = useState({ open: false, id: "", editData: "" });
  const [defaultFields, setDefaultFields] = useState([]);
  const [selectedFields, setSelectedFields] = useState([]);
  const [deleteLoading, setDeleteLoading] = useState(false);
  const [bulkUploadPopupState, setBulkUploadPopupState] = useState({ open: false });
  const [groupDownloadPopupState, setgroupDownloadPopupState] = useState({ open: false });
  const [showErrorPopUp, setShowErrorPopUp] = useState();
  const [checkedList, setCheckedList] = useState([]);

  const order = [
    "name", "passport_number", "candidate_id", "job_position_name",
    "visa_profession_name", "nationality_name", "religion",
    "visa_block_number", "visa_reference_number", "visa_stamping_date", "status",
  ];

  useEffect(() => {
    const fields = updateDefaultFieldsArray({ candidateData, order }) || [];
    setDefaultFields(fields);
    setSelectedFields(fields.filter((d) => d.default));
  }, [candidateData]);

  const allData = candidateData?.candidates?.filter((d) => d?.status === "VISA STAMPED") || [];

  const filtered = searchTerm.trim()
    ? allData.filter((item) =>
        selectedFields.some((f) =>
          String(item[f.value] ?? "").toLowerCase().includes(searchTerm.toLowerCase())
        )
      )
    : allData;

  const totalPages = Math.max(1, Math.ceil(filtered.length / pageSize));
  const safePage = Math.min(currentPage, totalPages);
  const pageData = filtered.slice((safePage - 1) * pageSize, safePage * pageSize);

  useEffect(() => { setCheckedList([]); }, [safePage, pageSize]);

  const handleSelectAll = () => {
    if (checkedList.length === pageData.length) setCheckedList([]);
    else setCheckedList(pageData.map((d) => d?.id));
  };

  const handleCheckBox = (rowId) => {
    if (checkedList.includes(rowId)) setCheckedList((p) => p.filter((id) => id !== rowId));
    else setCheckedList((p) => [...p, rowId]);
  };

  const deleteData = async (rowID) => {
    const response = await deleteRowDelete(projectId, { candidate: [{ id: rowID }] }, setCandidateListData, dispatch);
    if (response.completed) setOPenDeletePopup({ open: false, id: "" });
  };

  const handleGroupDelete = async () => {
    const arr = checkedList.map((id) => ({ id }));
    const response = await deleteGroupDelete(projectId, { candidate: arr }, setCandidateListData, setDeleteLoading, dispatch);
    if (response.completed) setGroupDeletePopupState({ open: false });
  };

  const FilterColumn = () => null;
  const ResetFilter = () => { setFilteringKeys({}); setSearchTerm(""); };

  return (
    <div className="p-2">
      <Tooltip id="update-visa-details-tooltip" place="bottom" className="z-50 max-w-sm w-full" opacity="1" />
      <Tooltip id="update-visa-details-tooltip-2" place="bottom" opacity="0.7" followCursor={true} />

      {editCandidatePopup?.open && (
        <EditUpdatedVisaCandidate showPromptElement={editCandidatePopup} setShowPromptElement={setEditCandidatePopup} candidateListData={candidateData} projectId={projectId} setCandidateListData={setCandidateListData} updateVisaDetails={true} ResetFilter={ResetFilter} />
      )}
      {showSettings && <SettingsPopup showPopup={showSettings} setShowPopup={setShowSettings} initialState={defaultFields} finalState={selectedFields} setFinalState={setSelectedFields} />}
      {openDeletePopup.open && <PromptElement showPromptElement={openDeletePopup} setShowPromptElement={setOPenDeletePopup} deleteHandler={deleteData} />}
      {groupDeletePopupState.open && <PromptElement showPromptElement={groupDeletePopupState} setShowPromptElement={setGroupDeletePopupState} deleteHandler={handleGroupDelete} />}
      {groupEditPopupState.open && (
        <GroupEditPopupVisaDetails popupState={groupEditPopupState} setPopupState={setGroupEditPopupState} candidateData={candidateData} setCandidateListData={setCandidateListData} checkedList={checkedList} ResetFilter={ResetFilter} />
      )}
      {filterView && (
        <CandidateFilterPopup filterView={filterView} setFilterView={setFilterView} candidateData={candidateData} setCandidateListData={setCandidateListData} FilterColumn={FilterColumn} ResetFilter={ResetFilter} filteringKeys={filteringKeys} />
      )}
      {bulkUploadPopupState.open && (
        <FileUploadPopup_VISA popupState={bulkUploadPopupState} setPopupState={setBulkUploadPopupState} setShowErrorPopUp={setShowErrorPopUp} setCandidateListData={setCandidateListData} />
      )}
      {groupDownloadPopupState.open && (
        <DownloadPDFPopup popupState={groupDownloadPopupState} setPopupState={setgroupDownloadPopupState} selectedRowsData={candidateData?.candidates?.filter((d) => checkedList.includes(d?.id))} company={candidateData?.company} />
      )}
      {showErrorPopUp && <CandidateErrorPopUp showErrorPopUp={showErrorPopUp} onToggle={() => setShowErrorPopUp(false)} title="Validation Error" />}

      {/* Toolbar */}
      <div className="flex flex-wrap gap-2 items-center w-full mb-4 flex-row-reverse">
        <SearchFilter searchTerm={searchTerm} onSearchChange={(val) => { setSearchTerm(val); setSearchWords(val ? val.trim().split(/\s+/) : []); setCurrentPage(1); }} placeholder="Search across all columns..." />
        <div className="flex flex-wrap gap-2 items-center">
          {/* Download Excel */}
          <div className="relative">
            <div className="peer">
              <button className="flex items-center gap-2 bg-blue text-white p-2 px-3 rounded-md text-sm">
                Download Excel <RiFileExcel2Line size="1.1rem" />
              </button>
            </div>
            <div className="hidden absolute right-0 top-full w-[14rem] bg-white shadow-xl rounded-lg pt-2 px-2 pb-2 ring-1 ring-slate-400 peer-hover:flex hover:flex flex-col gap-2 z-50">
              <button onClick={() => selectionList(candidateData, pageData, "VISA Details")} disabled={pageData.length <= 0}
                className="flex justify-center items-center gap-2 ring-1 ring-slate-300 font-semibold text-black bg-slate-50 p-2 px-3 rounded-md w-full text-xs disabled:bg-slate-300 disabled:cursor-not-allowed hover:bg-blue hover:text-white">
                VISA Details Report
              </button>
              <button onClick={() => visaDetailsTemplate(candidateData)}
                className="flex justify-center items-center gap-2 ring-1 ring-slate-300 font-semibold text-black bg-slate-50 p-2 px-3 rounded-md w-full text-xs hover:bg-blue hover:text-white">
                Template - Visa Details
              </button>
            </div>
          </div>
          <button onClick={() => setOpenCandidateUpload(true)} className="flex items-center gap-2 p-2 px-3 rounded-md bg-blue text-white text-sm">
            Upload VISA Details <AiOutlineCloudUpload size="1.1rem" />
          </button>
          <div data-tooltip-id="update-visa-details-tooltip" data-tooltip-content="Upload Candidate - Passport, VISA, Vaccine, Driving License, Signed Emp Contract, Signed Absent Policy.">
            <button onClick={() => setBulkUploadPopupState({ open: true })} className="flex items-center gap-2 p-2 px-3 rounded-md bg-blue text-white text-sm">
              Document Bulk Upload <AiOutlineCloudUpload size="1.1rem" />
            </button>
          </div>
          {/* Action dropdown */}
          <div className="relative">
            <div className="peer">
              <button className="flex items-center gap-2 bg-blue text-white p-2 px-3 rounded-md text-sm">
                Action <HiOutlineSquaresPlus size="1.1rem" />
              </button>
            </div>
            <div className="hidden absolute right-0 top-full w-[12rem] bg-white shadow-xl rounded-lg pt-2 px-2 pb-2 ring-1 ring-slate-400 peer-hover:flex hover:flex flex-col gap-1 z-50">
              <button onClick={() => setGroupEditPopupState({ open: true })} disabled={checkedList.length === 0 || checkedList.length > 1}
                className="flex justify-center items-center gap-2 bg-blue text-white p-2 px-3 rounded-md w-full text-xs disabled:bg-blue/70 disabled:cursor-not-allowed">
                Edit <FaUserEdit size="1.1rem" />
              </button>
            </div>
          </div>
          <button className="flex items-center gap-2 bg-blue text-white p-2 px-3 rounded-md text-sm disabled:bg-blue/70 disabled:cursor-not-allowed" onClick={() => setFilterView(true)} disabled={pageData.length <= 0}>
            Filter <AiOutlineFilter size="1.1rem" />
          </button>
          <button onClick={() => setShowSettings(true)} className="disabled:cursor-not-allowed" disabled={pageData.length <= 0}>
            <IoSettingsOutline size="1.2rem" />
          </button>
        </div>
      </div>

      <TableAllocatedVisaDetails VisaDetails={candidateData?.project_visa} />

      {/* Table */}
      <div className="overflow-x-auto !bg-white rounded-lg shadow max-h-[70vh] mt-3">
        <table className="min-w-full">
          <thead className="bg-gray-50 sticky top-0 z-20 shadow-sm">
            <tr className="bg-gray-50">
              <th className="px-6 py-4 text-left text-base font-semibold text-gray-700 uppercase tracking-wider bg-gray-50" style={{ backgroundColor: '#f9fafb' }}>
                <div className="flex items-center gap-2 cursor-pointer" onClick={handleSelectAll}>
                  <input type="checkbox" readOnly checked={checkedList.length === pageData.length && pageData.length > 0} className="checkbox checkbox-sm" />
                </div>
              </th>
              <th className="px-6 py-4 text-left text-base font-semibold text-gray-700 uppercase tracking-wider bg-gray-50 whitespace-nowrap" style={{ backgroundColor: '#f9fafb' }}>S.NO.</th>
              {selectedFields.map((f) => (
                <th key={f.id} className="px-6 py-4 text-left text-base font-semibold text-gray-700 uppercase tracking-wider bg-gray-50 whitespace-nowrap" style={{ backgroundColor: '#f9fafb' }}>{f.title}</th>
              ))}
              <th className="px-6 py-4 text-left text-base font-semibold text-gray-700 uppercase tracking-wider bg-gray-50 whitespace-nowrap" style={{ backgroundColor: '#f9fafb' }}>Action</th>
            </tr>
          </thead>
          <tbody className="bg-white">
            {allData.length === 0 ? (
              <tr><td colSpan={selectedFields.length + 3} className="px-6 py-8 text-center text-gray-500">No visa stamped candidates found.</td></tr>
            ) : pageData.length === 0 ? (
              <tr><td colSpan={selectedFields.length + 3} className="px-6 py-8 text-center text-gray-500">{`No results found for "${searchTerm}"`}</td></tr>
            ) : (
              pageData.map((data, index) => (
                <tr
                  key={data?.id}
                  data-tooltip-id={data?.candidate_file?.status !== "Completed" ? "update-visa-details-tooltip-2" : undefined}
                  data-tooltip-content="Mandatory documents are not uploaded for this candidate."
                  className={`border-b-[1.5px] border-slate-100 hover:bg-gray-50 ${data?.candidate_file?.status !== "Completed" ? "bg-red/10" : ""}`}
                >
                  <td className="px-6 py-6 whitespace-nowrap">
                    <input type="checkbox" checked={checkedList.includes(data?.id)} onChange={() => handleCheckBox(data?.id)} className="checkbox checkbox-sm" />
                  </td>
                  <td className="px-6 py-6 whitespace-nowrap text-base text-gray-700">{(safePage - 1) * pageSize + index + 1}</td>
                  {selectedFields.map((f) => (
                    <td key={f.id} className="px-6 py-6 whitespace-nowrap text-base text-gray-700">
                      <Highlighter searchWords={searchWords} autoEscape textToHighlight={data[f.value] !== undefined && data[f.value] !== null ? String(data[f.value]) : "-"} />
                    </td>
                  ))}
                  <td className="px-6 py-6 whitespace-nowrap">
                    <button className="p-1 px-2 rounded-md ring-1 ring-slate-600" onClick={() => setEditCandidatePopup({ open: true, id: data?.id, editData: data })}>
                      <CiEdit size="1.4rem" />
                    </button>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      <PaginationControls currentPage={safePage} totalPages={totalPages} pageSize={pageSize} totalRecords={filtered.length} pageSizeOptions={PAGE_SIZE_OPTIONS} onPageChange={(p) => setCurrentPage(p)} onPageSizeChange={(s) => { setPageSize(s); setCurrentPage(1); }} />
    </div>
  );
}
